import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequirePermission } from "@/components/universal/require-permission";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/_fulfillment-360")({
  component: FulfillmentLayout,
});

function FulfillmentLayout() {
  return (
    <RequirePermission permission="fulfillment_360" fallback={<NotFoundPage />}>
      <Outlet />
    </RequirePermission>
  );
}
